/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $getEmployeeDocumentByAprovalRequest = {
    properties: {
        approval: {
    type: 'number',
    isRequired: true,
},
    },
};